import React from "react";
import { Modal } from "antd";
import { VscDebugRestart } from "react-icons/vsc";
import { InfoCircleOutlined } from "@ant-design/icons";
import { IUserRecord } from "@/ts/common-types";

interface IResetPasswordModalProps {
    visible: boolean;
    selectedUser: IUserRecord | null;
    loading: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ResetPasswordModal: React.FC<IResetPasswordModalProps> = ({
    visible,
    selectedUser,
    loading,
    onConfirm,
    onCancel,
}) => {
    return (
        <Modal
            title={
                <div className="d-flex align-items-center gap-2">
                    <VscDebugRestart className="text-danger fs-5" />
                    <span className="fw-semibold">Reset Password Confirmation</span>
                </div>
            }
            open={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText="Yes, Reset Password"
            cancelText="Cancel"
            okButtonProps={{
                danger: true,
                loading: loading,
                disabled: !selectedUser
            }}
            cancelButtonProps={{
                disabled: loading
            }}
            width={500}
            centered
            maskClosable={!loading}
        >
            <div className="d-flex flex-column gap-3 py-3">

                <div className="alert alert-danger d-flex align-items-start p-3" role="alert">
                    <InfoCircleOutlined className="fs-4 text-danger flex-shrink-0 me-3" />
                    <div>
                        <h6 className="alert-heading mb-1">Are you sure you want to reset the password?</h6>
                        <p className="mb-0 small">
                            This will send a password reset email to the user. This action cannot be undone.
                        </p>
                    </div>
                </div>

                {selectedUser && (
                    <div className="border rounded p-3 bg-light">
                        <p className="small text-muted mb-1">You are resetting the password for:</p>
                        <p className="fw-bold text-dark mb-0">
                            {selectedUser.first_name} {selectedUser.last_name}
                        </p>
                        <p className="text-primary small mb-0">
                            {selectedUser.email}
                        </p>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ResetPasswordModal;